module.exports = __webpack_public_path__ + "img/Siegel.0014aa10.jpg";